import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoVeiculoManutencaoUnidata({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'veiculomanutencaounidata', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoVeiculoManutencaoUnidata({ payload }) {
  try {
    const { veic_placa, params } = payload;

    yield call(api.delete, `veiculomanutencaounidata/${veic_placa}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoveiculomanutencaounidata, params } = payload;

    yield call(
      api.post,
      'veiculomanutencaounidata',
      operacaoveiculomanutencaounidata
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/veiculomanutencaounidata');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { veic_placa } = payload;

    const { data } = yield call(
      api.get,
      `veiculomanutencaounidata/${veic_placa}`
    );

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoveiculomanutencaounidata, params } = payload;

    yield call(
      api.put,
      'veiculomanutencaounidata',
      operacaoveiculomanutencaounidata
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/veiculomanutencaounidata');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'veiculomanutencaounidata', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoveiculomanutencaounidata/OPERACAOVEICULOMANUTENCAOUNIDATA_IN_REQUEST',
    requestOperacaoVeiculoManutencaoUnidata
  ),
  takeLatest(
    '@operacaoveiculomanutencaounidata/DELETE_OPERACAOVEICULOMANUTENCAOUNIDATA',
    deleteOperacaoVeiculoManutencaoUnidata
  ),
  takeLatest(
    '@operacaoveiculomanutencaounidata/SUCCESS_REMOVE',
    requestOperacaoVeiculoManutencaoUnidata
  ),
  takeLatest(
    '@operacaoveiculomanutencaounidata/STORE_OPERACAOVEICULOMANUTENCAOUNIDATA',
    store
  ),
  takeLatest(
    '@operacaoveiculomanutencaounidata/FIND_OPERACAOVEICULOMANUTENCAOUNIDATA',
    find
  ),
  takeLatest(
    '@operacaoveiculomanutencaounidata/UPDATE_OPERACAOVEICULOMANUTENCAOUNIDATA',
    update
  ),
  takeLatest(
    '@operacaoveiculomanutencaounidata/RECORD_FILTERING',
    applyedFilters
  ),
]);
